export const ACTIVITY_PRIORITY = {
	NONE: 0,
	LOW: 1,
	MEDIUM: 2,
	HIGH: 3
} as const;
export type ActivityPriority = (typeof ACTIVITY_PRIORITY)[keyof typeof ACTIVITY_PRIORITY];
